import styled from 'styled-components';
import { userPanelElementStyles } from '../../../styles/sharedStyles';

export const StyledUserPanelAdditionElement = styled.div`
    ${userPanelElementStyles};
`;
